module.exports = __webpack_public_path__ + "static/media/gps-gris.e2573036.svg";